import { Box, Button, Link, Text, useColorModeValue } from "@chakra-ui/react";
import HeadphonesSupportLight from "../assets/headphonesSupport";

interface SupportButtonProps {
  link: string;
}

export const SupportButton = ({ link }: SupportButtonProps) => {
  const icon = useColorModeValue(
    <HeadphonesSupportLight color="white" />,
    <HeadphonesSupportLight color="black" />
  );
  return (
    <Box position="fixed" bottom="24px" right="24px">
      <Link href={link} target="_blank">
        <Button
          py="24px"
          px="24px"
          bgColor="brand.primary"
          textColor="brand.textLight"
          borderRadius="56px"
        >
          {icon}
          <Text fontSize="16px" marginLeft="6px" fontWeight="600">
            Support
          </Text>
        </Button>
      </Link>
    </Box>
  );
};

export default SupportButton;
